import { createElement } from "react";
import { Box, Tab, Tabs } from "@chakra-ui/react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundTabs(props) {
  return /*#__PURE__*/_jsx(Box, {
    className: "font-modern-era-medium",
    bottom: 0.5,
    children: props.tabs.length > 0 && /*#__PURE__*/_jsx(Tabs, {
      display: "flex",
      gap: 8,
      defaultIndex: props.selected,
      onChange: props.onChange,
      children: props.tabs.map((tab, index) => /*#__PURE__*/_jsxs(Tab, {
        color: "blackAlpha.600",
        fontSize: "lg",
        className: "flex items-center gap-2",
        _selected: {
          color: "black",
          borderBottom: "3px solid black"
        },
        children: [tab.icon && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/createElement(tab.icon, {
            className: "w-4 h-4"
          })
        }), tab.name]
      }, index))
    })
  });
}